const TOKEN_KEY = "token";
const REFRESH_KEY = "refresh_token";
const USER_KEY = "id_user";

export function readAuth() {
  return {
    token: localStorage.getItem(TOKEN_KEY),
    refreshToken: localStorage.getItem(REFRESH_KEY),
    userId: localStorage.getItem(USER_KEY),
  };
}

export function writeAuth(input: { token: string; refreshToken: string; userId: string }) {
  localStorage.setItem(TOKEN_KEY, input.token);
  localStorage.setItem(REFRESH_KEY, input.refreshToken);
  localStorage.setItem(USER_KEY, input.userId);
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
}
